export const siteInfo = {
  name: "看料大瓜",
  slogan: "提前蹲守，快人一步",
  tagline: "预告前瞻 · 瓜田预警",
  description:
    "看料大瓜专注娱乐与商业圈层的爆料预告前瞻，把正在发酵的蛛丝马迹整理成清晰的预警信号，让你在事件引爆前就蹲好位置。",
  email: "hello@kanliaodagua.example.com",
  replyNote: "爆料线索与内容纠错，欢迎随时来信。",
};

export const categories = [
  {
    id: "film",
    name: "影视圈",
    slug: "film",
    icon: "ri-movie-2-line",
    desc: "剧组动态、选角变动、档期博弈与剧集撤改播的一手信号。",
    count: 42,
  },
  {
    id: "music",
    name: "音乐圈",
    slug: "music",
    icon: "ri-mic-line",
    desc: "巡演排期、音乐节阵容、版权与合约变动的提前预警。",
    count: 27,
  },
  {
    id: "variety",
    name: "综艺坊",
    slug: "variety",
    icon: "ri-live-line",
    desc: "节目录制现场、嘉宾阵容调整与播出编排的蛛丝马迹。",
    count: 19,
  },
  {
    id: "live",
    name: "网红直播",
    slug: "live",
    icon: "ri-broadcast-line",
    desc: "头部主播动态、连麦翻车、选品供应链纠纷的发酵线索。",
    count: 33,
  },
  {
    id: "biz",
    name: "商业瓜",
    slug: "biz",
    icon: "ri-briefcase-4-line",
    desc: "创始人互撕、股权对赌、融资与人事变动的风向捕捉。",
    count: 24,
  },
  {
    id: "sports",
    name: "文体圈",
    slug: "sports",
    icon: "ri-basketball-line",
    desc: "转会窗、赛事申办、俱乐部运营背后的博弈与信号。",
    count: 15,
  },
];

export const forecasts = [
  {
    id: 1,
    slug: "summer-costume-drama-recast",
    title: "暑期档古装剧换角风波：三家片方的沉默博弈",
    categoryId: "film",
    categoryName: "影视圈",
    stage: "高概率引爆",
    stageTone: "primary",
    heat: 96,
    readTime: 6,
    date: "2026-09-11",
    author: "瓜田哨兵",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20abstract%20film%20clapperboard%20and%20drama%20masks%20made%20of%20geometric%20shapes%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20melon%20green%20accents%2C%20soft%20grain%20texture%2C%20minimal%20composition%2C%20no%20text%2C%20magazine%20cover%20aesthetic%2C%20elegant%20modern%20design&width=1200&height=800&seq=gossip-film-recast-01&orientation=landscape",
    excerpt:
      "原定女主连续三天未进组，替补演员已进入剧本围读。换角与否尚未官宣，但片方的沉默本身就是信号。",
    tags: ["换角", "古装剧", "档期博弈"],
    signals: [
      "原定女主连续三天缺席剧本围读",
      "替补演员的经纪人出现在片方办公地",
      "剧集官方账号悄悄修改了主演置顶顺序",
      "原定开机发布会延后，未给出具体日期",
    ],
    timeline: [
      { time: "9月6日", text: "原定女主缺席首次剧本围读，片方称「行程调整」。" },
      { time: "9月8日", text: "替补演员进入围读现场，仅参与前三集内容。" },
      { time: "9月10日", text: "官方账号主演置顶顺序出现变动，随后又改回。" },
      { time: "9月11日", text: "开机发布会宣布延后，通告中未提及新日期。" },
    ],
    body: [
      {
        type: "p",
        text: "连续三天的缺席，比任何一份声明都更有说服力。当一位原本板上钉钉的主演突然从所有公开行程中消失，第一反应往往不是「她生病了」，而是「事情有变」。这一次，变化来得比预想更快。",
      },
      {
        type: "h3",
        text: "沉默的三方与一条被改回去的置顶",
      },
      {
        type: "p",
        text: "片方从未承认换角，但我们留意到一个细节：剧集官方账号在深夜修改了主演的置顶顺序，把原本排在第二位的人提到了第一位，两小时后又被改回。这种反复，通常意味着内部尚未谈妥，但已经有人在为「Plan B」铺路。",
      },
      {
        type: "quote",
        text: "在正式官宣之前，最容易暴露真实意图的，永远是那些被默默调整过的顺序。",
      },
      {
        type: "h3",
        text: "接下来要蹲什么",
      },
      {
        type: "p",
        text: "如果替补演员开始出现在大合照、定妆照或后台探班物料里，基本可以确认换角已经完成，只等一个合适的时机公开。反之，如果原定女主在三天内更新一条状态宽松的动态，风波大概率会以「虚惊一场」收场。",
      },
    ],
  },
  {
    id: 2,
    slug: "singer-tour-schedule-shift",
    title: "顶流歌手巡演临时改档，背后的排期暗战",
    categoryId: "music",
    categoryName: "音乐圈",
    stage: "发酵中",
    stageTone: "secondary",
    heat: 88,
    readTime: 5,
    date: "2026-09-10",
    author: "蹲守员小瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20a%20stylized%20microphone%20and%20sound%20wave%20lines%20over%20abstract%20concert%20stage%20lights%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20accents%2C%20subtle%20paper%20grain%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20magazine%20aesthetic%2C%20elegant%20modern%20design&width=1200&height=800&seq=gossip-tour-schedule-02&orientation=landscape",
    excerpt:
      "两站演唱会突然对调档期，票务系统同步冻结。艺人方与主办方各执一词，但观众已经察觉异常。",
    tags: ["巡演", "改档", "票务"],
    signals: [
      "两站场地档期一日内完成对调",
      "票务平台短暂显示「暂缓开票」",
      "主办方新增了一场未命名的加场",
      "场馆周边酒店被同一批账号批量预订",
    ],
    timeline: [
      { time: "9月7日", text: "票务页面短暂出现「暂缓开票」提示，随后恢复。" },
      { time: "9月9日", text: "相邻两站的开演日期完成对调。" },
      { time: "9月10日", text: "主办方预告函中出现一场尚未公布的加场信息。" },
    ],
    body: [
      {
        type: "p",
        text: "巡演改档本身并不稀奇，稀奇的是「对调」这种方式。两站日期互换，意味着行程没有减少，只是在重新排列顺序——这通常发生在嘉宾档期、场馆空档或售票预期三者中至少有一项发生了冲突。",
      },
      {
        type: "h3",
        text: "被冻结的十分钟",
      },
      {
        type: "p",
        text: "9月7日晚上，票务页面出现了大约十分钟的「暂缓开票」状态。虽然很快恢复，但这一瞬间暴露了后台正在调整的事实。结合随后两站日期的对调，可以判断调整并非临时起意，而是已经推进了一段时间。",
      },
      {
        type: "h3",
        text: "真正的看点在哪",
      },
      {
        type: "p",
        text: "如果接下来出现一场「神秘嘉宾」的加场预告，那么这次改档的真正目的就会浮出水面：不是补救，而是加码。主办方想在收官站制造更大的声量，这比单纯的档期冲突更值得关注。",
      },
    ],
  },
  {
    id: 3,
    slug: "variety-show-guest-exit",
    title: "综艺常驻嘉宾疑似退出，录制现场的三次空位",
    categoryId: "variety",
    categoryName: "综艺坊",
    stage: "预备爆料",
    stageTone: "accent",
    heat: 79,
    readTime: 4,
    date: "2026-09-09",
    author: "瓜田哨兵",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20empty%20chairs%20on%20a%20stylized%20variety%20show%20set%20with%20geometric%20spotlight%20shapes%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20melon%20green%20accents%2C%20soft%20grain%20texture%2C%20minimal%20composition%2C%20no%20text%2C%20magazine%20infographic%20aesthetic%2C%20elegant%20modern%20design&width=1200&height=800&seq=gossip-variety-guest-03&orientation=landscape",
    excerpt:
      "最新一期录制的座位图少了一个名字，补位嘉宾的物料却在当晚就位。节目组尚未回应。",
    tags: ["综艺", "常驻嘉宾", "补位"],
    signals: [
      "录制座位图少了一个固定名字",
      "补位嘉宾的宣传物料连夜赶工",
      "嘉宾的社交账号删除了节目相关置顶",
      "节目组内部群发布了「以最终版本为准」的通知",
    ],
    timeline: [
      { time: "9月8日", text: "录制座位图中缺少一位常驻名字。" },
      { time: "9月8日 晚", text: "补位嘉宾的官宣物料进入排期。" },
      { time: "9月9日", text: "节目组通知内部「以最终播出为准」。" },
    ],
    body: [
      {
        type: "p",
        text: "座位图是最不会撒谎的东西。它需要精确到每个人站哪、坐哪、镜头怎么过，一旦有变动，几乎不可能不留痕迹。这一次，痕迹留在了最新一期的座位安排上。",
      },
      {
        type: "h3",
        text: "为什么是「疑似」而不是「确认」",
      },
      {
        type: "p",
        text: "因为补位嘉宾的物料虽然就位，但节目组仍保留着原嘉宾的往期内容，没有做任何删减。这通常说明谈判还在进行——退，或者以另一种形式回归。",
      },
      {
        type: "h3",
        text: "蹲守建议",
      },
      {
        type: "p",
        text: "留意下期预告的镜头语言。如果原嘉宾只出现在群像远景里，而近景与互动几乎为零，那基本可以确认其常驻身份已经动摇。",
      },
    ],
  },
  {
    id: 4,
    slug: "livestream-host-connection-incident",
    title: "头部主播连麦翻车后续：品牌方集体静默",
    categoryId: "live",
    categoryName: "网红直播",
    stage: "高概率引爆",
    stageTone: "primary",
    heat: 94,
    readTime: 5,
    date: "2026-09-09",
    author: "蹲守员小瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20abstract%20livestream%20screen%20frame%20and%20chat%20bubbles%20in%20geometric%20shapes%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20accents%2C%20subtle%20grain%20texture%2C%20minimal%20modern%20composition%2C%20no%20text%2C%20magazine%20cover%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=gossip-livestream-host-04&orientation=landscape",
    excerpt:
      "一场原本普通的连麦，因为一句话失控。二十四小时后，三个合作品牌同时下架了联名物料的入口。",
    tags: ["直播", "连麦", "品牌合作"],
    signals: [
      "三个合作品牌同时隐藏联名入口",
      "直播间回放被下架，仅保留剪辑版",
      "主播团队取消了未来两天的直播预告",
      "两家MCN机构开始互相取证",
    ],
    timeline: [
      { time: "9月8日 晚", text: "连麦过程中出现争议发言，直播中断约三分钟。" },
      { time: "9月9日 早", text: "直播回放被下架，官方账号仅保留剪辑版。" },
      { time: "9月9日 午", text: "三个品牌陆续隐藏联名活动入口。" },
    ],
    body: [
      {
        type: "p",
        text: "品牌方的动作永远比声明更快。当三个合作方在同一个上午悄悄下掉联名入口时，事情的性质已经从「直播事故」转向了「合作风险」。",
      },
      {
        type: "h3",
        text: "沉默本身就是态度",
      },
      {
        type: "p",
        text: "截至目前，没有任何一方发布正式声明。但下架入口、取消预告、互相取证这一连串动作，已经构成了完整的应对链条。对品牌而言，切割的成本远低于观望。",
      },
      {
        type: "h3",
        text: "接下来看什么",
      },
      {
        type: "p",
        text: "如果主播团队在48小时内发布道歉或说明，事件大概率会以「阶段性降温」收场；如果继续沉默，通常意味着还有未公开的后续，届时波及范围可能扩大到更多合作方。",
      },
    ],
  },
  {
    id: 5,
    slug: "founders-public-feud-stake-bet",
    title: "新消费品牌创始人互撕，股权对赌进入倒计时",
    categoryId: "biz",
    categoryName: "商业瓜",
    stage: "发酵中",
    stageTone: "secondary",
    heat: 81,
    readTime: 6,
    date: "2026-09-08",
    author: "商业观察席",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20abstract%20corporate%20chess%20pieces%20and%20broken%20contract%20paper%20shapes%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20gold%20accents%2C%20subtle%20grain%20texture%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20business%20magazine%20aesthetic&width=1200&height=800&seq=gossip-founder-feud-05&orientation=landscape",
    excerpt:
      "两位创始人在同一天各自发了一封内部信，内容互相指向。对赌协议的时间窗口，只剩不到一个月。",
    tags: ["股权", "对赌", "内部信"],
    signals: [
      "两位创始人同日发布互相指向的内部信",
      "公司官网管理团队页面出现短暂空白",
      "投资人名单中一家机构悄然撤下品牌露出",
      "员工内部论坛相关讨论帖被批量隐藏",
    ],
    timeline: [
      { time: "9月7日", text: "两位创始人分别发布内部信，时间相隔不到四小时。" },
      { time: "9月8日", text: "官网管理团队页面短暂空白后恢复。" },
      { time: "9月8日 晚", text: "一家投资机构撤下了对该品牌的露出。" },
    ],
    body: [
      {
        type: "p",
        text: "内部信本该是最私密的沟通形式，但当两封信在同一天先后流出，它就成了公开表态的工具。措辞之间的微妙对立，比任何一场发布会都更接近真相。",
      },
      {
        type: "h3",
        text: "对赌窗口的数学题",
      },
      {
        type: "p",
        text: "对赌协议的截止日往往决定了一家公司内部的紧张程度。当时间只剩不到一个月，任何一次公开分歧都可能被放大成「控制权之争」的前奏。",
      },
      {
        type: "h3",
        text: "三个可蹲的信号",
      },
      {
        type: "p",
        text: "一看投资人是否继续站台，二看核心团队是否有高管变动公告，三看供应链合作方是否开始缩短账期。这三项里任意两项同时出现，基本可以判断内部已经进入实质博弈阶段。",
      },
    ],
  },
  {
    id: 6,
    slug: "esports-transfer-window-final-hours",
    title: "电竞转会窗最后 72 小时：三支战队的抢人筹码",
    categoryId: "sports",
    categoryName: "文体圈",
    stage: "预备爆料",
    stageTone: "accent",
    heat: 76,
    readTime: 5,
    date: "2026-09-08",
    author: "赛场前哨",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20abstract%20game%20controller%20and%20geometric%20bracket%20lines%20forming%20a%20team%20logo%20shape%2C%20warm%20cream%20paper%20background%2C%20melon%20green%20and%20coral%20red%20accents%2C%20soft%20grain%20texture%2C%20minimal%20modern%20composition%2C%20no%20text%2C%20magazine%20aesthetic&width=1200&height=800&seq=gossip-esports-transfer-06&orientation=landscape",
    excerpt:
      "转会窗口即将关闭，三支战队围绕同一名选手展开拉锯。合同细节之外，真正的变量是出场时间。",
    tags: ["转会窗", "电竞", "合约"],
    signals: [
      "同一选手的试训记录出现在三支战队系统中",
      "其中一支战队提前解约了替补席成员",
      "选手社交账号关注列表出现批量变动",
      "教练组深夜直播时被弹幕追问，选择回避",
    ],
    timeline: [
      { time: "9月7日", text: "三支战队的试训名单中出现同一名选手。" },
      { time: "9月8日", text: "一支战队提前完成替补席解约。" },
      { time: "9月8日 晚", text: "教练在直播中被追问，只说「等官宣」。" },
    ],
    body: [
      {
        type: "p",
        text: "转会窗的最后三天，往往是消息最密集的时候。三支战队同时盯上一个人，这种局面下，钱通常不是决定因素，出场时间才是。",
      },
      {
        type: "h3",
        text: "筹码不止是薪资",
      },
      {
        type: "p",
        text: "一支战队提前腾出替补席，说明他们对签约志在必得；另一支拥有更完整的体系，能提供稳定的首发位置。对选手来说，后者往往更有吸引力。",
      },
      {
        type: "h3",
        text: "官宣前的最后信号",
      },
      {
        type: "p",
        text: "关注选手账号的关注列表。如果开始出现新队友的互动，而旧队友的互动减少，往往意味着转会已经进入收尾阶段，只等窗口关闭后的统一公布。",
      },
    ],
  },
  {
    id: 7,
    slug: "drama-pulled-streaming-settlement",
    title: "剧集撤档改网播，平台与制作方的结算拉锯",
    categoryId: "film",
    categoryName: "影视圈",
    stage: "发酵中",
    stageTone: "secondary",
    heat: 73,
    readTime: 5,
    date: "2026-09-07",
    author: "瓜田哨兵",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20abstract%20television%20screen%20and%20streaming%20play%20button%20in%20geometric%20shapes%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20accents%2C%20subtle%20grain%20texture%2C%20minimal%20composition%2C%20no%20text%2C%20media%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=gossip-drama-streaming-07&orientation=landscape",
    excerpt:
      "一部已经完成前期宣传的剧集临时撤档，转而以网播形式上线。分歧不在内容，在结算方式。",
    tags: ["撤档", "网播", "结算"],
    signals: [
      "线下投放物料被紧急下刊",
      "平台首页推荐位替换为另一部剧集",
      "制作方与平台的联合声明确认「改为线上播出」",
      "剧集官微删除了定档倒计时内容",
    ],
    timeline: [
      { time: "9月5日", text: "线下站台投放物料下刊。" },
      { time: "9月6日", text: "平台推荐位更换，原剧集海报消失。" },
      { time: "9月7日", text: "双方发布联合说明，确认改为线上播出。" },
    ],
    body: [
      {
        type: "p",
        text: "「改为线上播出」是一句非常温和的表述。它掩盖了一个更现实的问题：双方在分成比例上没能谈拢，而档期已经等不及了。",
      },
      {
        type: "h3",
        text: "为什么是结算，而不是内容",
      },
      {
        type: "p",
        text: "如果问题出在内容，通常会看到更长时间的延期与修改；而这次从撤档到改网播，中间只隔了两天。这种速度，指向的是商业条款而非审查。",
      },
      {
        type: "h3",
        text: "后续值得关注",
      },
      {
        type: "p",
        text: "留意上线首周的会员拉新数据。如果表现超出预期，制作方在后续合作中的议价空间会明显改善；反之，这个案例可能会成为行业里被反复引用的参照。",
      },
    ],
  },
  {
    id: 8,
    slug: "music-festival-lineup-deleted",
    title: "音乐节阵容官宣又删帖，主办方在等什么",
    categoryId: "music",
    categoryName: "音乐圈",
    stage: "预备爆料",
    stageTone: "accent",
    heat: 69,
    readTime: 4,
    date: "2026-09-06",
    author: "蹲守员小瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20abstract%20festival%20stage%20and%20geometric%20ticket%20shapes%20with%20sound%20waves%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20melon%20green%20accents%2C%20soft%20paper%20grain%2C%20minimal%20modern%20composition%2C%20no%20text%2C%20magazine%20aesthetic&width=1200&height=800&seq=gossip-festival-lineup-08&orientation=landscape",
    excerpt:
      "阵容海报在上午十点发布，十一点被删除。主办方的客服口径从「已确认」变成了「以最终为准」。",
    tags: ["音乐节", "阵容", "官宣"],
    signals: [
      "阵容海报发布一小时后被删除",
      "客服口径由「已确认」改为「以最终为准」",
      "部分艺人的转发微博同步消失",
      "票务平台的早鸟票页面显示「调整中」",
    ],
    timeline: [
      { time: "9月6日 10:00", text: "阵容海报发布，名单包含六组艺人。" },
      { time: "9月6日 11:00", text: "海报被删除，部分转发内容同步消失。" },
      { time: "9月6日 14:00", text: "客服口径变更，票务页面显示「调整中」。" },
    ],
    body: [
      {
        type: "p",
        text: "删帖的速度，往往和签约的进度成反比。发布一小时后撤回，说明阵容里至少有一组艺人尚未最终敲定，而海报提前上线了。",
      },
      {
        type: "h3",
        text: "问题多半出在哪一行",
      },
      {
        type: "p",
        text: "从转发内容同步消失这一点看，被撤回的大概率是名单中的头部艺人。中腰部艺人通常不会要求删除转发，只有涉及较大商业合作的一方，才会对提前曝光如此敏感。",
      },
      {
        type: "h3",
        text: "蹲守提示",
      },
      {
        type: "p",
        text: "留意早鸟票页面的恢复时间。如果在一周内重新开放，说明谈判已经结束；若持续「调整中」，则可能整个档期都需要重新规划。",
      },
    ],
  },
  {
    id: 9,
    slug: "livestream-selection-crisis",
    title: "直播带货选品翻车，供应链公司连夜发声明",
    categoryId: "live",
    categoryName: "网红直播",
    stage: "高概率引爆",
    stageTone: "primary",
    heat: 85,
    readTime: 5,
    date: "2026-09-05",
    author: "蹲守员小瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20editorial%20illustration%20of%20abstract%20shopping%20cart%20and%20falling%20geometric%20boxes%20with%20warning%20shape%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20accents%2C%20subtle%20grain%20texture%2C%20minimal%20modern%20composition%2C%20no%20text%2C%20magazine%20aesthetic%2C%20high%20detail&width=1200&height=800&seq=gossip-livestream-selection-09&orientation=landscape",
    excerpt:
      "一款热销品在直播后被集中投诉，供应链公司连夜切割责任。争议的核心，是谁来定义「合规」。",
    tags: ["选品", "供应链", "责任划分"],
    signals: [
      "供应链公司在凌晨发布切割声明",
      "相关商品链接在多个直播间被下架",
      "平台客服收到集中投诉，进入专项处理",
      "主播团队的选品流程被网友翻出旧规",
    ],
    timeline: [
      { time: "9月4日 晚", text: "直播间集中出现关于该商品的投诉。" },
      { time: "9月5日 凌晨", text: "供应链公司发布声明，称「已尽到提示义务」。" },
      { time: "9月5日 午", text: "多个直播间下架该商品链接。" },
    ],
    body: [
      {
        type: "p",
        text: "凌晨发布的声明，通常是为了抢占第一解释权。当供应链公司比主播团队更早发声，说明他们希望把责任边界划在直播环节，而不是生产环节。",
      },
      {
        type: "h3",
        text: "争议的焦点不是产品",
      },
      {
        type: "p",
        text: "消费者关心的是「谁来负责」，而各方争论的是「谁先说的」。这种错位，是选品类纠纷最常见的走向，也最容易拖长处理周期。",
      },
      {
        type: "h3",
        text: "接下来看什么",
      },
      {
        type: "p",
        text: "看主播团队是否公开完整的选品与质检流程。愿意公开，说明底气足；如果只是重复「已下架处理」，则意味着问题可能比表面更复杂。",
      },
    ],
  },
];

export const trendSignals = [
  { time: "今日 08:20", level: "预警", text: "三家片方同日更新片单，两部古装剧的主演顺序均被调整。" },
  { time: "今日 11:45", level: "信号", text: "某头部主播团队取消未来两天的全部直播预告。" },
  { time: "今日 14:10", level: "发酵", text: "新消费品牌管理团队页面短暂空白，一小时后恢复。" },
  { time: "今日 17:30", level: "预警", text: "音乐节早鸟票页面状态由「售罄」改为「调整中」。" },
  { time: "今日 20:05", level: "信号", text: "电竞选手指南中，三名选手的训练赛记录同步消失。" },
];

export const watchSteps = [
  {
    icon: "ri-radar-line",
    title: "捕捉信号",
    desc: "从公开行程、物料变动、账号动态中，筛出真正异常的那几条线索，而不是围观情绪。",
  },
  {
    icon: "ri-git-branch-line",
    title: "串联时间线",
    desc: "把零散的动作按时间排列，看清事件从哪一步开始偏移，以及下一步最可能落在哪里。",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "给出预警",
    desc: "用清晰的概率语言告诉你哪些值得蹲、哪些只是虚惊，方便你决定要不要提前关注。",
  },
];

export const testimonials = [
  {
    name: "追剧不追瓜",
    role: "内容社区用户",
    quote:
      "以前热点出来才反应过来，现在提前一晚就知道该蹲哪个词条了。时间线整理得很清楚，不是那种只会喊「大瓜来了」的号。",
  },
  {
    name: "林小满",
    role: "娱乐内容运营",
    quote:
      "做选题的时候会先来看看有没有前瞻，信号那一栏特别有用，能直接判断这件事值不值得跟。",
  },
  {
    name: "阿哲",
    role: "品牌市场从业者",
    quote: "商业瓜那一栏的分析比较克制，会区分「已确认」和「推测」，不会为了热度硬下结论。",
  },
  {
    name: "橙子汽水",
    role: "资深吃瓜选手",
    quote: "最喜欢的是它会告诉你「接下来看什么」，看完知道该关注哪个细节，而不是看完还是一头雾水。",
  },
];

export const faqs = [
  {
    q: "看料大瓜的前瞻内容是怎么来的？",
    a: "我们只整理公开可见的信息，比如官方账号的物料调整、行程变动、平台页面状态变化等，再按时间顺序串联成信号清单。所有推断都会标明依据，不会把猜测写成结论。",
  },
  {
    q: "「预警」和「爆料」有什么区别？",
    a: "预警是提前提示「这件事值得关注」，描述的是正在发酵的迹象；爆料则是对结果的直接陈述。我们绝大多数内容属于前者，只有信号足够密集时才会标记为「高概率引爆」。",
  },
  {
    q: "为什么有的前瞻最后没有应验？",
    a: "前瞻本身是概率判断，不是预告片。娱乐与商业事件存在大量临时变量，我们会保留每一次的判断依据，方便你回看逻辑是否有偏差，而不是只展示命中结果。",
  },
  {
    q: "如何第一时间收到新的前瞻提醒？",
    a: "在页面底部留下邮箱订阅蹲守提醒即可。我们会在发布重要前瞻时发送一封简短的提醒，不会高频打扰，也不会把你的邮箱用于其他用途。",
  },
  {
    q: "可以投稿线索或者指正内容吗？",
    a: "非常欢迎。你可以通过关于页面的联系方式发来线索或纠错说明，并附上可公开的信息来源，我们会逐一核实后更新相关内容。",
  },
  {
    q: "看料大瓜会发布个人隐私信息吗？",
    a: "不会。我们只讨论事件本身与公开可见的动作，不涉及任何个人隐私、家庭信息或未经证实的私人传闻，这也是我们内容原则里最重要的一条。",
  },
];

export const contentPrinciples = [
  {
    icon: "ri-shield-check-line",
    title: "只谈公开信息",
    desc: "所有信号均来自公开渠道的可见变化，不涉及隐私、不揣测私人生活。",
  },
  {
    icon: "ri-scales-3-line",
    title: "标明判断依据",
    desc: "每一条前瞻都附带信号清单与时间线，让你可以自行验证推理是否成立。",
  },
  {
    icon: "ri-refresh-line",
    title: "及时更新结论",
    desc: "事件走向变化时，我们会更新原有内容并标注修改时间，而不是删帖了事。",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "不制造对立",
    desc: "讨论事件与商业逻辑，不做人身攻击，也不鼓励粉丝之间的对立与互撕。",
  },
];

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "预告前瞻", to: "/forecast" },
  { label: "瓜田分类", to: "/topics" },
  { label: "关于我们", to: "/about" },
];